import { Trans } from '@lingui/macro';
import _ from 'lodash';
import { useState } from 'react';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NgpTwoButtonDialog from '../../dialog-two-button/NgpTwoButtonDialog';

function CollectorDeleteDialog({ open, setOpen, onConfirm, collectors }) {
    const [confirmed, setConfirmed] = useState(false);

    const handleCleanup = () => {
        setConfirmed(false);
    };

    return (
        <NgpTwoButtonDialog
            title={<Trans>Delete Collector</Trans>}
            confirmButtonText={<Trans>Delete</Trans>}
            cancelButtonText={<Trans>Cancel</Trans>}
            open={open}
            setOpen={setOpen}
            onCloseFunc={handleCleanup}
            onConfirm={onConfirm}
            closeInTitleBar={false}
            confirmButtonDisabled={!confirmed}
        >
            <div>
                <Trans>Data Deletion Warning</Trans>
            </div>
            <div>
                <span>
                    <Trans>The following collector will be deleted: </Trans>
                </span>
                <span className="collector-name">
                    {_.map(collectors, (collect, index) => (
                        <div key={collect._id}>
                            {collect.name}
                            {index !== collectors.length - 1 ? ', ' : '.'}
                        </div>
                    ))}
                </span>
                <span>All data on this collector will be permanently deleted and cannot be recovered.</span>
            </div>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={confirmed}
                        onChange={(e) => {
                            setConfirmed(e.target.checked);
                        }}
                    />
                }
                label="I understand that this operation permanently deletes data on this collector."
            />
        </NgpTwoButtonDialog>
    );
}

export default CollectorDeleteDialog;
